import { Component, OnInit } from '@angular/core';
import { HttpService } from '../service/http.service';
import { Student } from '../student';

@Component({
  selector: 'app-students',
  templateUrl: './students.component.html',
  styleUrls: ['./students.component.css']
})
export class StudentsComponent implements OnInit {

  students: Student[] = [];

  constructor(
    private httpService: HttpService
  ) { }

  ngOnInit(): void {
    this.httpService.getAllStudents().subscribe(res => {
      this.students = res;
      console.log(this.students);
    });
  }

}
